import * as React from "react";
import { CurrentPdfContext, type CurrentPdfContextType } from "@/contexts/setPdfContext.consts";

const noopFn = () => {};

const defaultContext: CurrentPdfContextType = {
  activeTab: null,
  setActiveTab: noopFn,
  currentPdfId: null,
  setCurrentPdfId: noopFn,
  isRightDrawerVisible: false,
  setIsRightDrawerVisible: noopFn,
  rightDrawerContent: "pdf",
  setRightDrawerContent: noopFn,
  handleCitationClick: noopFn,
  currentCitation: null,
  setCurrentCitation: noopFn,
  handleFileSelect: noopFn,
  setSelectedFiles: noopFn,
  selectedFiles: [],
  setRootItem: noopFn,
  rootItem: undefined,
  setArtefacts: noopFn,
  setSelectedArtefactId: noopFn,
  selectedArtefactId: null,
  artefacts: [],
};

export const useCurrentPdf = () => {
  const context = React.useContext(CurrentPdfContext);
  return context ?? defaultContext;
};
